import { useState } from 'react';
import type { BookingDrawerMode } from '../components/BookingFormDrawer';

/** A booking row as the dialogs need it: enough to show and to prefill. */
export interface BookingRef {
  id: string;
  workshopName: string;
  startsAt: string;
  endsAt: string;
}

/** Which dialog is open on a truck's schedule: the booking drawer (create or move), the cancel modal, or the window finder. At most one at a time. */
export function useScheduleDialogs() {
  const [drawer, setDrawer] = useState<BookingDrawerMode | null>(null);
  const [cancelling, setCancelling] = useState<BookingRef | null>(null);
  const [isFinding, setIsFinding] = useState(false);

  return {
    drawer,
    cancelling,
    isFinding,
    openCreate: (initialWindow?: { startsAt: string; endsAt: string }) => setDrawer({ kind: 'create', initialWindow }),
    openMove: (booking: BookingRef) => setDrawer({ kind: 'move', booking }),
    openCancel: (booking: BookingRef) => setCancelling(booking),
    openFinder: () => setIsFinding(true),
    /** The finder hands its window to a new booking, so one closes as the other opens. */
    bookFoundWindow: (window: { startsAt: string; endsAt: string }) => {
      setIsFinding(false);
      setDrawer({ kind: 'create', initialWindow: window });
    },
    closeDrawer: () => setDrawer(null),
    closeCancel: () => setCancelling(null),
    closeFinder: () => setIsFinding(false),
  };
}
